module.exports = __webpack_public_path__ + "img/uec-black.6c5e7f9f.png";